import TaskRunner from 'concurrent-tasks'
import that from '@/main'
import { hiprint } from '@'
import { postAction } from '@api/manage'

let printSuccessArr = []
let printComplete = false

const incrementPrintCount = (callback = () => {}, printIds = []) => {
    const detailIdArr = printSuccessArr.map(x => x.detailId)
    postAction('/productPi/modifyPrintNums', detailIdArr).then(res => {
        if (res.code === 200 && res.success === true) {
            console.log('===========================打印次数记录成功===========================', callback)
            const isCallbackFunction = typeof callback === 'function';
            if (isCallbackFunction) {
                console.log('回调函数是有效的函数，开始执行...', detailIdArr);
                callback(printIds);
                console.log('回调函数执行完毕。');
            } else {
                console.log('回调函数不是有效的函数，不执行。');
            }
        } else {
            that.$message.error(res.message)
        }
    }).catch(error => {
        console.error('===========================打印次数记录失败===========================', error.message)
    })
}

/**
 * 全都打印
 * @param list 数据列表
 * @param panel 选中模板
 */
// 入口，循环方法
const startPrint = (list, panel, num, parentDone, parentRunner, obj, callback) => {
    printSuccessArr = []
    printComplete = false
    const runner = new TaskRunner()
    // 同时执行数量
    runner.setConcurrency(1)
    const task = []
    const tasksKey = `open${Date.now()}`
    const fieldList = getfield(panel) ? getfield(panel) : []
    const printIds = []; // 用于收集打印的 ID
    const chunkSize = 7
    const splitResult = Array.from({ length: Math.ceil(list.length / chunkSize) }, (_, i) =>
        list.slice(i * chunkSize, (i + 1) * chunkSize)
    );

    splitResult.forEach((c, pIndex) => {
        task.push(done => {
            let printDataArr = []
            c.forEach((originData, index) => {
                const oldDataCount = obj ? ((obj.pageNumber - 1) * obj.limit) : 0
                const nowIndex = parseInt(pIndex + '' + index) + 1 + oldDataCount
                const key = `文件${nowIndex}`
                let printData = {}
                if (originData.detailId) {
                    printIds.push(originData.detailId);
                }
                fieldList.forEach(item => {
                    // 日期类型数据处理
                    if (item.dateFormat) {
                        // 转换格式
                        printData[item.name] = formatDate(originData[item.value], item.dateFormat)
                        return false
                    }
                    // 非日期类型字段
                    printData[item.name] = originData[item.value]
                })

                printDataArr.push({
                    key,
                    nowIndex,
                    printData,
                    originData
                })
            })
            realPrint({
                runner,
                done,
                printDataArr,
                tasksKey,
                panel,
                num,
                parentDone,
                callback,
                printIds
            })
        })
    })

    runner.addMultiple(task)
    openNotification(runner, tasksKey, parentRunner)
}

// 主体打印方法
const realPrint = (param) => {
    const { runner, done, printDataArr, tasksKey, panel, num, parentDone, callback, printIds } = param;
    printDataArr.forEach(item => {
        console.log(item.nowIndex, item.key)
        that.$notification.info({
            key: item.key,
            placement: 'topRight',
            duration: 2,
            message: `正在准备打印第 ${item.nowIndex} 张,序列号：${item.originData.serialNumber}`,
            description: '队列运行中...',
        })
    })

    // 将模板格式内容
    let template = getFormatPanel(param.panel)
    template.copies = param.num;
    // 生产成模板
    let hiprintTemplate = new hiprint.PrintTemplate({
        template: template,
    })
    // 开始打印
    hiprintTemplate.print2(param.printDataArr.map(x => x.printData))
    // 监听事件-成功
    hiprintTemplate.on('printSuccess', function () {
        let info = param.runner.tasks.list.length > 1 ? '准备打印下一张' : '已完成打印'

        param.printDataArr.forEach(item => {
            printSuccessArr.push(item.originData)
            that.$notification.success({
                key: item.key,
                placement: 'topRight',
                duration: 0.5,
                message: item.key + ' 打印成功',
                description: info,
            })
        })

        // 回调，下一次打印
        param.done()

        if (param.runner.tasks.total == param.runner.tasks.completed) {
            console.log('============================本轮全部完成============================')
            console.log('printSuccessArr', printSuccessArr)
            printComplete = true
            incrementPrintCount(callback, printIds)
            console.log('============================下一轮go============================')
            param.parentDone()
        }
        if (!param.runner.isBusy()) {
            that.$notification.close(param.tasksKey)
        }
    })
}

const openNotification = (runner, tasksKey, parentRunner) => {
    that.$notification.open({
        key: tasksKey,
        message: '队列运行中...',
        duration: 0,
        placement: 'topLeft',
        description: '点击关闭所有任务',
        btn: h => {
            return h(
                'a-button',
                {
                    props: {
                        type: 'danger',
                        size: 'small',
                    },
                    on: {
                        click: () => {
                            that.$notification.close(tasksKey)
                            // 详情请查阅文档
                            parentRunner.removeAll()
                            runner.removeAll()
                            incrementPrintCount()
                            that.$message.info('已移除所有任务')
                        },
                    },
                },
                '关闭任务',
            )
        },
    })
}

// 格式化模板
const getFormatPanel = (obj) => {
    let panels = [
        {
            index: 0,
            height: Number(obj.paperHeight),
            width: Number(obj.paperWidth),
            printElements: []
        }
    ]
    obj.datas.forEach(item => {
        const panelOption = JSON.parse(item.option)
        panels[0].printElements.push(panelOption)
    })
    return { panels }
}

// 获取模板中出现的字段，并匹配对应字段
const getfield = (obj) => {
    console.log(obj, 'obj');
    /**
     * 字段对应
     * @param productDate 生产日期
     * @param invalDate 失效日期
     * @param effectivitDate 有效日期
     * @param batchNumber 生产批号
     * @param sterilizationNumber 灭菌批号
     * @param serialNumber 序列号
     * @param productDi 二维码
     */
    const fieldObj = {
        productDate: 'productDate',
        invalDate: 'invalDate',
        effectivitDate: 'effectivitDate',
        batchNumber: 'batchNumber',
        sterilizationNumber: 'dBatchNumber',
        serialNumber: 'serialNumber',
        qrcode: 'productDi',
        productDi: 'productDi',
        barcode: 'productDi',
        testData: 'productDi',
        securityCode: 'securityCode',
        pi: 'pi',
        di: 'di',
        verifySearch: 'verifySearch',
        productName: 'productName',
        productNo: 'productNo',
        traceSearch: 'traceSearch',
        specificationModel: 'specificationModel',
    }
    // 未匹配字段
    const fieldList = []
    // 已匹配字段
    const formatList = []
    obj.datas.forEach(item => {
        const row = JSON.parse(item.option)
        
        // 其他字段处理
        if (row.options.field != undefined) {
            const x = row.options.field
            let obj = { name: x, value: fieldObj[x] }
            if (row.options.dateFormat != undefined) {
                obj.dateFormat = row.options.dateFormat
            } else if (['productDate', 'invalDate', 'effectivitDate'].includes(x)&&row.options.dateFormat == undefined) {
                obj.dateFormat = 'YYYYMMDD'
            }
            console.log(' obj.dateFormat',  obj.dateFormat)
            formatList.push(obj)
        }
    })
    return formatList
}

const formatDate = (time, format) => {
    if (!time) {
        return '----'
    }
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        } else if (typeof time === 'string') {
            time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '')
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }

    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    var hours = String(date.getHours()).padStart(2, '0');
    var minutes = String(date.getMinutes()).padStart(2, '0');
    var seconds = String(date.getSeconds()).padStart(2, '0');

    var formattedDate = format
      .replace('YYYY', year)
      .replace('YY', year.toString().slice(-2))
      .replace('MM', month)
      .replace('DD', day)
      .replace('HH', hours)
      .replace('mm', minutes)
      .replace('ss', seconds);

    return formattedDate;
}

export {
    startPrint
}
